import { render, staticRenderFns } from "./MaterialSelector.vue?vue&type=template&id=13b30154&scoped=true"
import script from "./MaterialSelector.vue?vue&type=script&lang=js"
export * from "./MaterialSelector.vue?vue&type=script&lang=js"
import style0 from "./MaterialSelector.vue?vue&type=style&index=0&id=13b30154&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b30154",
  null
  
)

export default component.exports